//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {insightService} from "@/insight-service";
import {missionService} from "@/misson-service";
import Outcome from "@/components/mission/Outcome";
import Drilldown from "@/components/mission/Drilldown";
import MissionMetrics from '@/components/mission/MissionMetrics.vue';
import {mapGetters, mapMutations} from "vuex";
import MissionDialog from "@/components/mission/MissionDialog";
import Graph from "@/components/mission/Graph";
import MissionActivity from "@/components/mission/MissionActivity";

export default {
  name: "Mission",
  data: () => ({
    mission: undefined,
    model: undefined,
    data: [],
    baseLine: [],
    values: [],
    versions: [],
    modelInputs: [],
    scope: "",
    showDialog: false,
    saving: false,
    editMode: false,
    doneReviews: 0,
    availableReviews: 0,
    missionLoaded:false,
  }),

  components: {
    MissionActivity,
    Graph,
    MissionDialog,
    MissionMetrics,
    Outcome,
    Drilldown
  },

  computed: {
    ...mapGetters(["currentClient", "projectId"]),

    properties() {
      if (this.mission) {
        return this.mission.properties ? this.mission.properties : {};
      }
      return {};
    },

    created() {
      if (this.mission) {
        return insightService.formatDateWithYear(this.mission.properties['dc:created']);
      }
      return '...';
    },

    currentGoal() {
      const goalValues = this.missionData();
      return parseFloat(goalValues && goalValues[goalValues.length - 1],0).toFixed(0);
    },

    title() {
      return this.properties["dc:title"];
    },

    categories() {
      if (this.mission) {
        return this.properties['ai_mission:categories_focus'];
      }
      return [];
    },

    priority() {
      return this.properties["ai_mission:priority"];
    },

    goal() {
      return this.properties["ai_mission:goal"];
    },

    assignees() {
      return this.properties["ai_mission:assignees"];
    },

    modelId() {
      return this.properties["ai_mission:model"];
    },

    evaluations() {
      let results = this.mission.contextParameters.mission.evaluation_result;
      return results ? results : [];
    },

    modelProperties() {
      return this.model.properties ? this.model.properties : {};
    },

    missionOutputs() {
      if (this.properties['ai_mission:output_focus']) {
        return [this.properties['ai_mission:output_focus']];
      }
      if (this.model) {
        return this.modelProperties['ai_model:outputs'].map((e) => e.name);
      }
      return [];
    },
  },

  watch: {
    mission: function (newVal) {
      this.data = missionService.dataPoints(newVal);
      this.baseLine = missionService.goalLine(newVal);
      this.versions = missionService.evaluationLabels(newVal);
      this.values = missionService.values(this.mission);
      this.missionLoaded = true;
      this.$refs.fetchModel
          .get()
          .then((aiModel) => {
            this.model = aiModel;
          })
          .catch((err) => {
            this.displayError(err);
          });
    },
    model: function () {
      this.scope = this.modelProperties["ai_model:doc_type"];
      this.modelInputs = this.modelProperties["ai_model:inputs"].map(
          (e) => e.name
      );
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
    }),
    cancel() {
      this.showDialog = false;
    },
    init() {
      this.showDialog = false;
      this.$refs.fetchMission
          .get()
          .then(mission => {
            this.mission = mission;
            this.getAnnotations('ANNOTATED');
            this.getAnnotations('MISSING');
          })
          .catch((error) => {
            this.displayError(error);
          });
    },
    navigateToDashboard() {
      this.$router.push({name: "missions"});
    },
    priorityStyle(priority) {
      return {
        'color': `${insightService.getPriorityIcon(priority).color}`,
        'border-color': `${insightService.getPriorityIcon(priority).color}`
      };
    },

    startAction() {
      this.$router.push({
        name: "annotation",
        params: {id: this.mission.uid},
      });
    },

    deleteAction() {
      this.$refs.deleteMission.input = this.mission.uid;
      this.$refs.deleteMission
          .execute()
          .then(() => {
            this.displaySuccess(this.$t("model.missions.delete.success"));
            this.navigateToDashboard();
          })
          .catch((error) => {
            this.displayError(error);
          });
    },
    openEdit() {
      this.editMode = true;
      this.showDialog = true;
    },
    missionData() {
      return this.mission && missionService.dataPoints(this.mission);
    },

    getAnnotations(type) {
      var nuxeo = this.$refs.aiCloudConnect.client;
      insightService
          .getAnnotationsForModel(nuxeo, this.projectId, this.mission.uid, type)
          .then(response => {
            if (type === 'ANNOTATED') {
              this.doneReviews = response.doc_count;
            } else {
              this.availableReviews = response.doc_count;
            }
          })
          .catch(error => {
            console.error(error);
          });
    }
  },
};
